import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useMe } from '../../../organisation/useMe';
import { casePersonInternalApi } from '../../../apis';
import { FindCasePersonsPageRequest } from '../../../api-internal';

export const CASE_PERSONS_QUERY_KEY = 'casePersons';

export const useQueryCasePersonsPage = ({ handle, page, size }: FindCasePersonsPageRequest) => {
  const { currentOrganisation } = useMe();

  return useQuery({
    queryKey: [CASE_PERSONS_QUERY_KEY, 'page', handle, page, size, currentOrganisation?.id],
    queryFn: async () => {
      return await casePersonInternalApi.findCasePersonsPage({ handle, page, size });
    },
    placeholderData: keepPreviousData,
    enabled: !!currentOrganisation?.id && !!handle,
  });
};

export const useAttachCasePersons = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ handle, externalIds }: { handle: string; externalIds: string[] }) => {
      return casePersonInternalApi.attachCasePersons({
        handle,
        internalApiAttachCasePersonsRequest: { externalIds },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CASE_PERSONS_QUERY_KEY] });
    },
  });
};

export const useDetachCasePersons = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ handle, externalIds }: { handle: string; externalIds: string[] }) => {
      return casePersonInternalApi.detachCasePersons({
        handle,
        internalApiDetachCasePersonsRequest: { externalIds },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CASE_PERSONS_QUERY_KEY] });
    },
  });
};
